import api from './authService';
import { UserProfile, UpdateUserProfileRequest } from '../types/user';

export const userProfileService = {
  async getMyProfile(): Promise<UserProfile> {
    const response = await api.get('/user-profile');
    return response.data;
  },

  async getUserProfileById(userId: string): Promise<UserProfile> {
    const response = await api.get(`/user-profile/${userId}`);
    return response.data;
  },

  async updateMyProfile(data: UpdateUserProfileRequest): Promise<void> {
    await api.put('/user-profile', data);
  },

  async updateUserProfileById(userId: string, data: UpdateUserProfileRequest): Promise<void> {
    await api.put(`/user-profile/${userId}`, data);
  },

  async uploadProfileImage(file: File): Promise<{ imageUrl: string }> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/user-profile/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  async deleteProfileImage(): Promise<void> {
    await api.delete('/user-profile/delete-image');
  },

  async uploadProfileImageForUser(userId: string, file: File): Promise<{ imageUrl: string }> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/user-profile/${userId}/upload-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  async deleteProfileImageForUser(userId: string): Promise<void> {
    await api.delete(`/user-profile/${userId}/delete-image`);
  },
};
